import { gql } from '@apollo/client';
import { USER } from '../fragments';

export const CREATE_PASSWORD = gql`
  mutation CreatePassword($id: ID!, $otp: String!, $newPassword: String!) {
    createPassword(input: { id: $id, otp: $otp, newPassword: $newPassword }) {
      ...user
    }
  }
  ${USER}
`;
